import { Transform } from 'class-transformer';
import { dateTransformer } from 'src/lib/utilities/api/class-transformer-types';

export class AbDrillDownTranscriptStudentModel {
	student_uid: number;
	student_name: string;
	@Transform(dateTransformer)
	timestamp: number;
}
